<template>
	<div>
		<h2>Create Room</h2>
		<form class="create-room" method="post" @submit.prevent="onSubmit">
			<p>
				<label for="room_name">Title: </label>
				<input id="room_name" v-model="title" type="text" />
			</p>
			<p>
				<label for="room_username">Username: </label>
				<input id="room_username" v-model="username" type="text" />
			</p>
			<p>
				<input type="submit" />
			</p>
		</form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			title: null,
			username: null,
		};
	},
	methods: {
		onSubmit() {
			this.$store.dispatch('create_room', {
				title: this.title,
				username: this.username,
			});
		},
	},
};
</script>
